import React, { useState, useEffect, useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import FileUploadTable from "components/Content/CustomTable/FileUploadTable";
import { Button } from "@mui/material";
import ButtonStyle from "components/Button/ButtonStyle.module.css";

import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";

import { apiGet } from "app/Services/ApiService";
import { apiUrls, contractorApiUrls } from "common/ApiUrls";

import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import ContractorFileUploadsDialog from "components/Content/Modal/ContractorFileUploadsDialog";

function Uploads(props) {
  const { companyId, error } = useContext(PrivateRoutesContext);
  const [openModal, setOpen] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [contractList, setContractList] = useState([]);
  const availableUploadTypes = ['B4A66DD8-120B-4817-B290-2F178C4B0D13'];

  // FILE UPLOAD START
  useEffect(() => {
    console.log(`current company ${companyId}`)
    getUserUploads(companyId);
    fetchContracts()
  }, [companyId]);

  const getUserUploads = (companyId) => {
    console.log('getting user uploads')
    setIsLoading(true);

    apiGet(apiUrls.getUserUploads(companyId)).then(
      (response) => {
        setFetchedData(response.data);
        setIsLoading(false);
      }
    ).catch(
      (response) => {
        error.setTitle("An Error Occurred");
        error.setText("An Error occurred loading the files.");
        error.setDoShowError(true);
        setIsLoading(false);
      }
    );
  }

  const fetchContracts = (event) => {
    console.log('fetching contracts')
    // setCheckingData(true);
    apiGet(contractorApiUrls.getContracts())
      .then((response) => {
        console.log('fetch contracts')
        console.dir(response)
        setContractList(response.data)
      })
      .catch(function (error) {
        // console.log("THIS IS ERROR", error);          
        // setColumnsArray([]);
        // setFetchedData([]);
      })
      .then(function () {
        // always executed
        // setCheckingData(false);
      });
  };

  return (
    <div>
      <div className={TableStyle.tableWrapper}>
        <FileUploadTable
          uploadFiles={fetchedData}
          isLoading={isLoading}
          doDisplayErrorToggle={false}
          headerContents={<Button
            variant="outlined"
            color="primary"
            className={ButtonStyle.CsubmitBtn}
            onClick={() => setOpen(true)}
            startIcon={<PublishOutlinedIcon />}
          >
            Upload File
          </Button>}
        />

        {/* FILE UPLOAD MODAL */}
        <ContractorFileUploadsDialog openModal={openModal}
          handleClose={() => setOpen(false)}
          getUserUploads={getUserUploads}
          availableUploadTypes={availableUploadTypes}
          contractList={contractList} />
      </div>
    </div>
  );
}

export default Uploads;
